module.exports = __webpack_public_path__ + "img/img-video.7ec6f9a9.png";